<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" scrollable
                   :title="computedTitle" @show="onShow" :modal-loading="loading"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">

      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="body" type="textarea" :rows="7"/>
        </div>
      </div>

      <div class="comments-wrapper" v-if="comments && comments.length > 0">
        <div v-for="(com, index) in comments" :key="com.uuid"
             :class="{'border-bottom': index < comments.length - 1, 'selected-row': selectedUuid === com.uuid}"
             class="pt-2 pb-2">
          <b-media>
            <div class="pr-4">
                <span style="font-size: 1em">
                {{ com.body }}
              </span>
              <br>
              <div class="mt-1">
                <small class="mr-3 text-muted">
                  <font-awesome-icon icon="calendar" class="mr-1"/>
                  {{ $t('Created at') }} {{ com.created_at | toDateTime }}
                </small>
                <small class="text-muted">
                  <font-awesome-icon icon="user" class="mr-1"/>
                  {{ com.created_by.display_name }}
                </small>
              </div>
            </div>
          </b-media>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import FeatureRequestCommentModel from "@/modules/feature-request/FeatureRequestComment.model";
  import FeatureRequestService from "@/modules/feature-request/FeatureRequestService";

  const {mapState, mapActions} = createNamespacedHelpers('featureRequest');

  export default {
    name: "FeatureRequestCommentsModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: false,
        model: new FeatureRequestCommentModel(),
        comments: [],
        selectedUuid: null
      }
    },
    computed: {
      ...mapState({
        modal: state => state.commentsModal,
        featureRequest: state => state.commentsModal.featureRequest,
      }),
      computedTitle() {
        if (!this.featureRequest) {
          return "Reply"
        }
        return this.$i18n.t('Comments for {title}', {title: this.featureRequest.title})
      }
    },
    methods: {
      ...mapActions(['hideCommentsModal', 'onCommentCreated']),
      async onShow() {
        this.loading = true
        let response = await FeatureRequestService.getFeatureRequestComments({
          feature_request_uuid: this.featureRequest.uuid,
          limit: 10000,
          ordering: '-created_at',
          expand: 'created_by'
        })
        this.loading = false

        if (!response.success) {
          return
        }

        this.comments = response.body.results
      },
      onHidden() {
        this.model = new FeatureRequestCommentModel();
        this.hideCommentsModal();
      },
      async onSubmit() {
        await this.$refs.observer.reset();
        let validateSuccess = await this.$refs.observer.validate();
        if (!validateSuccess) {
          return;
        }

        this.loading = true;
        let response = await FeatureRequestService.createFeatureRequestComment({
          feature_request_uuid: this.featureRequest.uuid,
          body: this.model.body
        }, 'created_by')
        this.loading = false;

        if (!response.success) {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body)
          }
        } else {
          this.$toast('success', this.$t('New reply was successfully created'));
          this.comments.unshift(response.body)
          this.model.body = null
          this.onCommentCreated(this.featureRequest.uuid)
          await this.$refs.observer.reset();
        }

      },
    }
  }
</script>

<style scoped>
  .comments-wrapper {
    max-height: 25em;
    overflow-y: auto;
  }
</style>
